import { fetchLocstrings } from '../services/fetchLocstrings';
import { addLocstringsToStore } from './addLocstringsToStore';

export async function fetchLocstringFile(url: string): Promise<void> {
    addLocstringsToStore(await fetchLocstrings(url));
}
